import React, { useEffect, useState, useRef } from "react";
import { connect } from "react-redux";
import SearchBox from "../../../../components/formElements/searchbox/SearchBox";

import * as actions from "../../../../store/actions";

import PatientFileList from "./PatientFileList";
import { useInfiniteScroll } from "../../../../utils/pagination";

const PatientFiles = ({
  files,
  getPatientFiles,
  searchData,
  searchValue,
  searchPatientFiles,
  emptyPatientFiles,
  total_pages,
}) => {
  const [page, setPage] = useState(0);

  const floader = useRef(null);

  useInfiniteScroll(floader, () => {
    setPage(page => page + 1);
    console.log(page, "page");
  });

  useEffect(() => {
    if (page > 0 && page <= total_pages && !searchValue) {
      getPatientFiles("", page);
    } else if (
      searchValue &&
      searchValue.length >= 3 &&
      page > 0 &&
      page <= total_pages
    ) {
      getPatientFiles(searchValue, page);
    }
    // eslint-disable-next-line
  }, [page, searchValue]);

  useEffect(() => {
    emptyPatientFiles();
    // eslint-disable-next-line
  }, []);

  return (
    <>
      <div className="row m-3">
        <div className="col-md-5 mt-3 noteSearch">
          <SearchBox
            value={searchValue}
            onChange={val => {
              searchPatientFiles(val);
              setPage(1);
            }}
          />
        </div>
      </div>
      <div
        style={{
          paddingLeft: 30,
          paddingRight: 30,
        }}
      >
        <PatientFileList
          files={files}
          searchFiles={searchData}
          searchValue={searchValue}
        />
        <div ref={floader}></div>
      </div>
    </>
  );
};

const mapStoreToProps = ({ dashboard, validation }) => ({
  files: dashboard?.patients?.allFiles,
  searchData: dashboard?.patients?.searchFiles,
  searchValue: dashboard.patients?.searchFileValue,
  total_pages: dashboard.patients?.totalFilePages,
});

const mapDispatchToProps = dispatch => ({
  getPatientFiles: (q, page) => dispatch(actions.getPatientFiles(q, page)),
  searchPatientFiles: q => dispatch(actions.searchPatientFiles(q)),
  emptyPatientFiles: () => dispatch(actions.emptyPatientFiles()),
});

export default connect(mapStoreToProps, mapDispatchToProps)(PatientFiles);
